module.exports = __webpack_public_path__ + "static/media/md-call.719ec3ec.svg";